import * as React from "react";
import {PanelDashed} from "../../../../../components/PanelDashed";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";

interface IProps {
    disabled?: boolean;
    renewalPaymentFailed: boolean;
}

export class AddCarPanel extends React.Component<IProps> {

    public render() {
        let alertText: string;
        if (this.props.renewalPaymentFailed) {
            alertText = "Due to missed payment this action is not allowed";
        }
        return (
            <PanelDashed>
                <div className="panel-dashed-title">Add another car</div>
                <div className="panel-dashed-contents">You can add <span className="font-weight-semi-bold">up to three cars</span></div>
                <div className="panel-dashed-links">
                    <ButtonLink
                        id="addCar"
                        disabled={this.props.disabled || this.props.renewalPaymentFailed}
                        to="/journey/show/product/MotorInsurance/process/mtaAddCar"
                        alertMessage={alertText!}
                    >Add car</ButtonLink>
                </div>
            </PanelDashed>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/motor/yourCarsPage/AddCarPanel.tsx